import { useFormikContext } from "formik";
import { FC, Fragment } from "react";
import { IContactInfoArray } from "../../../../interfaces/Contact";
import { Grid } from "@mui/material";
import {
  // contactCommunicationDefaults,
  isExists,
  onlyEmailKey,
  onlyNumberKey,
} from "../../../../utils";
import { TextInput } from "../../../../components";
import useLocales from "../../../../hooks/useLocales";

export const ContactInfoArray: FC<IContactInfoArray> = ({
  contactCommunication,
  disabled,
}: any) => {
  const { translate } = useLocales();
  const { values }: any = useFormikContext();

  if (!isExists(contactCommunication)) {
    return null;
  }

  return (
    <Fragment>
      {!isExists(values.id) ? (
        <>
          <Grid item md={6} lg={6} xs={12} sm={12}>
            <TextInput
              name={`contact.contactCommunication.0.value`}
              label="E-Posta"
              type={"text"}
              autoComplete="off"
              onKeyPressCapture={(event: any) => onlyEmailKey(event)}
              disabled={values.isExistCustomer || disabled}
            />
          </Grid>
          <Grid item md={6} lg={6} xs={12} sm={12}>
            <TextInput
              name={`contact.contactCommunication.1.value`}
              label="Telefon Numarasi"
              type={"text"}
              autoComplete="off"
              onKeyPressCapture={(event: any) => onlyNumberKey(event)}
              disabled={values.isExistCustomer || disabled}
            />
          </Grid>
        </>
      ) : (
        <>
          <Grid item md={6} lg={6} xs={12} sm={12}>
            <TextInput
              name={`contactCommunication.0.value`}
              label="E-Posta"
              type={"text"}
              autoComplete="off"
              onKeyPressCapture={(event: any) => onlyEmailKey(event)}
              disabled={values.isExistCustomer || disabled}
            />
          </Grid>
          <Grid item md={6} lg={6} xs={12} sm={12}>
            <TextInput
              name={`contactCommunication.1.value`}
              label="Telefon Numarasi"
              type={"text"}
              autoComplete="off"
              onKeyPressCapture={(event: any) => onlyNumberKey(event)}
              disabled={values.isExistCustomer || disabled}
            />
          </Grid>
        </>
      )}
    </Fragment>
  );
};

export default ContactInfoArray;
